<div class="header">
  <div class="title">Rent Schedule</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<div class="dates-container">
  <table class="w-full text-left my-4 summary-table" mat-table [dataSource]="rentSchedules">
    <ng-container matColumnDef="as_of_date">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
        <span class="whitespace-nowrap"> Date </span>
      </th>
      <td mat-cell *matCellDef="let rentSchedule">
        <span class="pr-6 whitespace-nowrap">
          {{ rentSchedule.as_of_date | date: 'MM/dd/yyyy' }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="val">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
        <span class="whitespace-nowrap"> Amount </span>
      </th>
      <td mat-cell *matCellDef="let rentSchedule">
        <span class="pr-6 whitespace-nowrap">
          {{ rentSchedule.val | tsCurrency: 'USD' : 'symbol' : '1.0' }}
        </span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr class="order-row h-16" mat-row *matRowDef="let row; columns: displayColumns"></tr>
  </table>
</div>
